/**
 * Created by Rodrigo Quesada on 30/12/16.
 */

export function noop(): void {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/functions/functions.util.ts